export const GENERAL_HUB_ERROR_MODAL = 'general-hub-error-modal';
export const INVITE_PARTNER_MODAL = 'invite-partner-modal';
export const HUB_GENERAL_ERROR_OVERLAY = 'Hub General Error';
export const USER_PROFILE_FORM_MODAL = 'user-profile-form-modal';
export const PROSP_MODAL_ADD_ACCOUNTS = 'prosp-modal-add-accounts';
export const PROSP_MODAL_PERSONAL_DETAILS = 'prosp-modal-personal-details';
export const PROSP_MODAL_RISK_TOLERANCE_QUESTIONNAIRE = 'prosp-modal-risk-tolerance-questionnaire';
export const APPLICATION_PDF = 'application/pdf';
export const PARTICIPATION = 'Advice Invest Participation Level';
export const DATE_FORMAT_MM_DD_YYYY = 'MM-DD-YYYY';
export const WITHDRAWAL_OPTIONS = [
    { label: 'Less than 2 years', value: 250 },
    { label: '2 to 3 years', value: 251 },
    { label: '4 to 5 years', value: 252 },
    { label: '6 or 7 years', value: 253 },
    { label: '8 to 10 years', value: 254 },
    { label: '11 to 12 years', value: 255 },
    { label: '13 or 14 years', value: 256 },
    { label: '15 years', value: 257 },
    { label: '16 to 20 years', value: 258 },
    { label: 'More than 20 years', value: 259 },
];

export const LASTING_OPTIONS = [
    { label: 'Less than 6 years', value: 260 },
    { label: '6 to 10 years', value: 261 },
    { label: '11 to 15 years', value: 262 },
    { label: '16 to 25 years', value: 263 },
    { label: 'More than 25 years', value: 264 },
];

const Constants = {
    generalHubErrorModal: GENERAL_HUB_ERROR_MODAL,
    invitePartnerModal: INVITE_PARTNER_MODAL,
    hubGeneralErrorOverlay: HUB_GENERAL_ERROR_OVERLAY,
    participation: PARTICIPATION,
    userProfileFormModal: USER_PROFILE_FORM_MODAL,
    prospModalAddAccounts: PROSP_MODAL_ADD_ACCOUNTS,
    prospModalPersonalDetails: PROSP_MODAL_PERSONAL_DETAILS,
    prospModalRiskToleranceQuestionnaire: PROSP_MODAL_RISK_TOLERANCE_QUESTIONNAIRE,
    rtqLastingOptions: LASTING_OPTIONS,
    rtqWithdrawalOptions: WITHDRAWAL_OPTIONS,
    applicationPdf: APPLICATION_PDF,
    dateFormatMMddyyyy: DATE_FORMAT_MM_DD_YYYY,
}

export default Constants;
